import {Injectable} from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import {Router} from "@angular/router";


@Injectable()
export class MessageProvider {

    constructor(private snackBar: MatSnackBar, private router: Router) {
    }

    show(options){
        let message = '';
        if(typeof options === 'string'){
            message = options;
        }else{
            message = options.msg || '';
        }

        let label = options.label || 'Cerrar';
        let duration = options.duration || 4500;
        let extraClasses = options.extraClasses || [];

        const config = new MatSnackBarConfig();
        config.duration = duration;
        config.extraClasses = extraClasses;

        this.snackBar.open(message, label, config);
    }

    withReturn(options){
        let message = options.msg || '';
        let label = options.label || 'Cerrar';
        let duration = options.duration || 4500;
        let extraClasses = options.extraClasses || [];
        let action = options.action || '';

        const config = new MatSnackBarConfig();
        config.duration = duration;
        config.extraClasses = extraClasses;

        let ref = this.snackBar.open(message, label, config);

        let returnUrl = this.getListUrl( action );
        ref.onAction().subscribe(() => {
            this.router.navigate([ returnUrl ]);
        });
    }

    getListUrl(action){
        let indexesCount = 0;
        switch(action){
            case 'create': indexesCount = 1; break;
            case 'update': indexesCount = 2; break;
        }

        let returnUrl = '/';
        let url = this.router.url;
        let splitted = url.split("/");

        if (splitted.length > 0) {
            for (let i = 0; i < splitted.length - indexesCount; i++) {
                if(splitted[i] != ''){
                    returnUrl += splitted[i] + '/';
                }
            }
        }

        return returnUrl;
    }

}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/providers/message.provider.ts